import type { PartialWithFieldValue } from 'firebase/firestore'
import {
  collectionGroup,
  doc,
  query,
  where,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { StreamInterface } from 'tricklejs/dist/types'
import { modelListStream } from '../../firestore-mobx/stream'
import { getDocWithError } from '../../firestore-mobx/fetch'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import type { FirestoreRoomStateOutput } from './schema'
import { schema, writeSchema } from './schema'
import { RoomStateOutput } from '../../models/RoomStateOutput'

const converter: FirestoreDataConverter<FirestoreRoomStateOutput> = {
  toFirestore: (data: PartialWithFieldValue<FirestoreRoomStateOutput>) => {
    writeSchema.partial().parse(data)
    return data
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

export async function getRoomStateOutputTotalScore({
  repository,
  roomStateId,
  userId,
}: {
  repository: FirebaseRepository
  roomStateId: string
  userId: string
}): Promise<number | null> {
  const output = await getDocWithError(
    doc(
      repository.firestore,
      'room_state',
      roomStateId,
      'room_state_output',
      userId
    ).withConverter(converter),
    'FetchRoomStateOutputError'
  )
  return output.data()?.totalScore ?? null
}

export const getSectionRoomStateOutputs = (
  repository: FirebaseRepository,
  params: { sectionId: string }
): StreamInterface<RoomStateOutput[]> => {
  const ref = collectionGroup(
    repository.firestore,
    'room_state_output'
  ).withConverter(converter)

  const q = query(ref, where('sectionId', '==', params.sectionId))
  return modelListStream(repository, q, RoomStateOutput)
}
